import * as actions from './socketTypes'

export const callGrab = (socket, data) => {
    socket.emit(data.action, data)
    return {
        type: actions.SET_NOTHING,
    }
}